import { createContext, useContext, useState, type ReactNode } from 'react'

interface PageHeaderContextType {
  headerContent: ReactNode | null
  setHeaderContent: (content: ReactNode | null) => void
}

const PageHeaderContext = createContext<PageHeaderContextType | null>(null)

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [headerContent, setHeaderContent] = useState<ReactNode | null>(null)

  return (
    <PageHeaderContext.Provider value={{ headerContent, setHeaderContent }}>
      {children}
    </PageHeaderContext.Provider>
  )
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext)
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider')
  }
  return context
}
